<template>
    <div class="control">
        <input type="text"
               v-mask="'+7 (###) ###-##-##'"
               name="tel"
               v-model="tel"
               placeholder="+7 (xxx) xxx-xx-xx"
               @change="onChange($event)"
        >
    </div>
</template>

<script>
    import {mask} from 'vue-the-mask'

    export default {
        directives: {mask},
        props: {
            data: Object,
            vertical: Boolean
        },
        data: () => {
            return {
                tel: ''
            }
        },
        // mounted() {
        //     this.value = this.data.value
        // },
        methods: {
            onChange(event) {
                this.$emit('changeTelephone', event.target.value)
            }
        }
    }
</script>

<style scoped>
    .control {
        width: 100%;
    }

    .control span {
        display: block;
    }

    .control input {
        padding: 5px 10px;
    }

</style>

